import { render, staticRenderFns } from "./TrashInvoiceHistorical.vue?vue&type=template&id=59b80b88&scoped=true"
import script from "./TrashInvoiceHistorical.vue?vue&type=script&lang=js"
export * from "./TrashInvoiceHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b80b88",
  null
  
)

export default component.exports